import imgg from "../../src/assests/b2.png";
import Slider from "react-slick";
import "../Main.css";
import imgg1 from "../../src/assests/r1.png";
import imgg2 from "../../src/assests/y1.png";
import imgg3 from "../../src/assests/y2.png";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import {
  ChallengeFeatures,
  ChallengeTagline,
  ChallengeQrCard,
} from "./ChallengeSlide";

const Hero2 = () => {

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: true,
  };

  const data = [
    {
      span1: "We Build",
      span2: "Smart Healthcare Solutions",
      para: "Digitize hospital operations with our advanced HIMS & EMR systems for seamless patient care and management.",
      image: imgg3,
    },
    {
      span1: "We Provide",
      span2: "Simplified Payroll Management",
      para: "Boost your business with intelligent CRM solutions designed to enhance engagement and drive growth.",
      image: imgg1,
    },
    {
      span1: "We Provide",
      span2: "Empower Customer Relationships",
      para: "Boost your business with intelligent CRM solutions designed to enhance engagement and drive growth.",
      image: imgg2,
    },
    {
      span1: "Chennai",
      span2: "Challenge Us!",
      para: "Think your business deserves a world-class website?",
      image: "",
      challenge: true,
    },
  ];

  return (
    <section
      className="hero2-section mb-5 pb-5"
     style={{
    backgroundImage: `url(${imgg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
  }}
    >
      <div className="container"> 
        <div className="hero2-overlay w-100">
          <Slider {...settings}>
            {data.map((item, index) => (
  <div key={index}>
    <div className="d-flex flex-column align-items-center text-center justify-content-center px-3">
      
      <h1 className="hero2-title fw-bold">
        <span className="hero2-line1 d-block  fw-bold" style={{fontSize:"45px", fontWeight:"700",lineHeight:"100%", color: item.challenge ? "#e2d100" : undefined }}>{item.span1}</span>
        
        <span 
          className="hero2-line2 mb-2 d-block fw-bold "
          style={{fontSize:"40px", fontWeight:"500",lineHeight:"100%",
            
            color: index === 0 ? "#4DB6AC" : 
                   index === 1 ? "#1784A2" :
                   index === 2 ? "#FF7029" :
                   "#000"
          }}
        >
          {item.span2}
        </span>
      </h1>

      <p className="hero2-subtext  " style={{ color: "black", fontSize:"16px", fontWeight:"400",lineHeight:"100%"}}>
        {item.para}
      </p>
      {item.challenge && (
        <>
          <ChallengeFeatures />
          <ChallengeTagline />
        </>
      )}

     <Link to="/contact-us" style={{ textDecoration: "none", width: "100%" }}>
  <Button 
    variant="contained" 
    fullWidth 
    className="hero2-btn  px-4 py-2"
    style={{ maxWidth: "400px", background:"#383838" }} 
  >
    {item.challenge ? "Book Now" : "Get In Touch"}
  </Button>
</Link>
      <div className="hero2-img-wrapper mt-4 mb-5 pb-5">
        {item.challenge ? (
          <ChallengeQrCard />
        ) : (
          <img src={item.image} alt={item.span2} className="hero2-img img-fluid" />
        )}
      </div>

    </div>
  </div>
))}
          </Slider>
        </div>
      </div>
      <div className="mb-5 pb-5" >


      </div>
    </section>
  );
};

export default Hero2;